var Carousel = {};

//--------------
// Variables
//--------------
Carousel.prestationsList = '.js-prestations-list'
Carousel.prestationsListWrapper = '.js-prestations-list-wrapper'


//--------------
// Functions
//--------------

/**
 * Init prestations carousel
 * @return {void}
 */
Carousel.initPrestationsCarousel = function() {

  Carousel.prestationsSwiper = new App.Swiper(Carousel.prestationsList, {
    autoplay: {
      delay: 1500,
    },
      loop: true,
      slidesPerView: 4,
      speed: 800,
      freeMode: true,
      watchSlidesProgress: true,
      mousewheel: true,
      navigation: {
      nextEl: '.js-prestations-button-next',
      prevEl: '.js-prestations-button-prev',
    },
    pagination: {
      el: '.js-prestations-progressbar',
      type: 'progressbar',
    },
    breakpoints: {
      1340: {
        slidesPerView: 3,
      },
      991: {
        slidesPerView: 2,
      },
      767: {
        slidesPerView: 1,
      },
    }
  });

  $(Carousel.prestationsList).hover(function(){
    Carousel.prestationsSwiper.autoplay.stop();
  }, function(){
    Carousel.prestationsSwiper.autoplay.start();
  });
}


/**
 * Init carousel scripts
 * @return {[type]} [description]
 */
Carousel.init = function() {

  //-- Desktop (> 3)
  if($(window).width() > 991) {
    if($('.js-prestation-item').length > 3){
    	console.log('Desktop > 3');
      Carousel.initPrestationsCarousel();
      $(Carousel.prestationsListWrapper).removeClass('no-carousel');
    } else {
    	console.log('Desktop <= 3');
      $(Carousel.prestationsListWrapper).addClass('no-carousel');
    }
  } else if($(window).width() > 767 && $(window).width() < 992) {
    //-- Tablet (> 2)
    if($('.js-prestation-item').length > 2){
      Carousel.initPrestationsCarousel();
      $(Carousel.prestationsListWrapper).removeClass('no-carousel');
    } else {
      $(Carousel.prestationsListWrapper).addClass('no-carousel');
    }
  } else if($(window).width() < 768) {
    //-- Mobile (> 1)
    if($('.js-prestation-item').length > 1){
      Carousel.initPrestationsCarousel();
      $(Carousel.prestationsListWrapper).removeClass('no-carousel');
    } else {
      $(Carousel.prestationsListWrapper).addClass('no-carousel');
    }
  }
}

/**
 * Init carousel height scripts
 * @return {[type]} [description]
 */
Carousel.carouselHeight = function() {
  var carouselHeight = $(Carousel.prestationsListWrapper).height();
  $(Carousel.prestationsListWrapper).height(carouselHeight);
}

/**
 * Destroy carousel scripts
 * @return {void}
 */
Carousel.destroy = function() {

}

/**
 * Resize function
 * @return {void}
 */
Carousel.onResize = function() {
  //-- Set Carousel Height
  var carouselHeight = $(Carousel.prestationsListWrapper).find('.swiper-wrapper').height();
  $(Carousel.prestationsListWrapper).height(carouselHeight);
}

//--------------
// Execution
//--------------

Carousel.init();

Carousel.carouselHeight();

$(window).on('resize', function(){
  Carousel.onResize();
});

$('.cat-filter__link').click(function(){
	var categoryId = $(this).attr('data-id');

	// Change active button
	$('.cat-filter__link').removeClass('is-active');
	$(this).addClass('is-active');
	
	// Clear carousel
	$('.swiper-wrapper').html('').hide();

  $('.js-carousel-loading').addClass('is-active');
  $('.js-prestations-progressbar').removeClass('is-active');

	if(Carousel.prestationsSwiper){
		Carousel.prestationsSwiper.destroy();
	}
	$(Carousel.prestationsList).unbind('mouseenter mouseleave');

	// Fill carousel
	$.get('/api/prestation/'+categoryId+'/html')
	.done(function(data) {
		$('.swiper-wrapper').html(data.datas).hide();
    setTimeout(function(){
      $('.swiper-wrapper').fadeIn(800);
      $('.js-carousel-loading').removeClass('is-active');
      $('.js-prestations-progressbar').addClass('is-active');
    }, 500);

		Carousel.init();
	})
	.fail(function(err){
		console.log(err);
	});

});

module.exports = Carousel;
